import { getPluralize } from '@r1-frontend/shared/helpers/pluralize';
import { monthPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';
import { EPriceTypes } from '@r1-frontend/shared/types/EPriceTypes';

import { EPriceOperationTypes } from '~/src/entities/price';
import { sortFunction } from '~/src/helpers/functions';

export const convertDevicePrices = (device) => {
    if (!device) {
        return [];
    }

    const {
        posessPrice,
        posess_price,
        promo,
        leasing,
        leasingDuration,
        leasingPrice,
        leasing_dur,
        leasing_mon_price,
        leasingDurationSec,
        leasingPriceSec,
        leasing_dur_two,
        leasing_mon_price_two,
        prices,
    } = device;

    const convertedPrices = [];

    if (Array.isArray(prices) && prices.length > 0) {
        prices.filter(item => item.type === EPriceTypes.Possess)
            .forEach(item => {
                convertedPrices.push({
                    type: EPriceTypes.Possess,
                    value: item.value,
                    valuePromo: promo,
                });
            });

        prices.filter(item => item.type === EPriceTypes.Leasing)
            .forEach(item => {
                convertedPrices.push({
                    type: EPriceTypes.Leasing,
                    value: item.value,
                    duration: item.duration,
                });
            });
    } else {
        if (posessPrice || posess_price) {
            convertedPrices.push({
                type: EPriceTypes.Possess,
                value: posessPrice || posess_price,
                valuePromo: promo,
            });
        }

        if (Array.isArray(leasing)) {
            leasing.forEach(leasingPriceItem => {
                convertedPrices.push({
                    type: EPriceTypes.Leasing,
                    value: leasingPriceItem.price,
                    duration: leasingPriceItem.duration,
                });
            });
        } else {
            if (leasingDuration && leasingPrice || leasing_dur && leasing_mon_price) {
                convertedPrices.push({
                    type: EPriceTypes.Leasing,
                    value: leasingPrice || leasing_mon_price,
                    duration: leasingDuration || leasing_dur,
                });
            }

            if (leasingDurationSec && leasingPriceSec || leasing_dur_two && leasing_mon_price_two) {
                convertedPrices.push({
                    type: EPriceTypes.Leasing,
                    value: leasingPriceSec || leasing_mon_price_two,
                    duration: leasingDurationSec || leasing_dur_two,
                });
            }
        }
    }

    return convertedPrices;
};

/**
 *
 * @param {(import('~/src/entities/price').Price | import('~/src/entities/price').IPriceProps)[] prices}
 * @param {string | null} [domain]
 * @param {boolean} [longLabel]
 * @param {(a: any, b: any) => number} [sort]
 */
export const getPriceOptions = (
    prices,
    domain,
    longLabel = false,
    sort = sortFunction,
) => {
    const options = [];
    let hasNonEmptySortField = false;
    const pluralizeMonths = getPluralize(monthPluralize);

    prices
        .filter(item => item.type === EPriceTypes.Leasing)
        .forEach(item => {
            options.push({
                id: item.id,
                value: item.duration,
                label: longLabel
                    ? `В рассрочку на ${item.duration} ${pluralizeMonths(item.duration)} - ${item.value} ₽/мес.`
                    : `Рассрочка на ${item.duration} мес.`,
                price: item.value,
                pricePromo: item.valuePromo,
                type: EPriceTypes.Leasing,
                operType: EPriceOperationTypes.Leasing,
                sort: item.sort,
                requestId: item.requestId,
            });

            if (item.sort) {
                hasNonEmptySortField = true;
            }
        });

    prices
        .filter(item => item.type === EPriceTypes.Possess)
        .forEach(item => {
            const priceItem = {
                id: item.id,
                value: 0,
                label: 'Покупка',
                price: item.value,
                pricePromo: item.valuePromo,
                type: EPriceTypes.Possess,
                operType: EPriceOperationTypes.Possess,
                sort: item.sort,
                requestId: item.requestId,
            };

            if (item.sort) {
                hasNonEmptySortField = true;
            }

            if ('ekat' === domain) {
                options.unshift(priceItem);
            } else {
                options.push(priceItem);
            }
        });

    if (hasNonEmptySortField) {
        options.sort(sort);
    }

    return options;
};
